<template>
  <v-dialog :value="value" max-width="820" scrollable @input="$emit('input', $event)">
    <v-card v-if="value" class="ctg-card">
      <v-card-title class="ctg-head">
        <v-icon color="white" class="mr-2">mdi-book-open-page-variant</v-icon>
        <div class="ctg-head-text">
          <div class="ctg-head-title">{{ heading }}</div>
          <div class="ctg-head-sub">คู่มือทำรายการทีละขั้นตอน</div>
        </div>
        <v-spacer />
        <v-btn icon dark @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <!-- ผู้ดำเนินการ (legend) -->
        <div class="d-flex flex-wrap align-center mb-3">
          <span class="caption grey--text text--darken-1 mr-2">ผู้ดำเนินการ:</span>
          <v-chip v-for="(a, k) in actors" :key="k" x-small outlined :color="a.color" class="mr-1 mb-1">
            <v-icon left x-small>{{ a.icon }}</v-icon>{{ a.label }}
          </v-chip>
        </div>

        <!-- โหมดกลุ่มงาน: ลำดับภารกิจทั้งรอบปี -->
        <template v-if="group">
          <v-alert text dense color="info" border="left" class="mb-3">
            {{ group.desc }}
            <div v-if="group.flow.length" class="caption mt-1">
              ภารกิจเรียงตามลำดับที่มักเกิดขึ้นในรอบปี — คลิกเพื่อดูขั้นตอนของแต่ละภารกิจ
            </div>
          </v-alert>
          <div v-if="!group.flow.length" class="grey--text text--darken-1 mb-2">
            กลุ่มงานนี้ไม่มีกำหนดการ — ใช้เมนูได้ตลอดเวลา
          </div>
          <v-expansion-panels v-else v-model="openPanel" accordion>
            <v-expansion-panel v-for="(key, i) in group.flow" :key="key">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-avatar size="26" color="primary" class="mr-3 white--text caption font-weight-bold">
                    {{ i + 1 }}
                  </v-avatar>
                  <span class="font-weight-medium">{{ guides[key].title }}</span>
                  <v-chip v-if="statusOf(key)" x-small :color="statusOf(key).color" dark class="ml-2">
                    {{ statusOf(key).text }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <guide-body :guide="guides[key]" @navigate="go" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- โหมดภารกิจเดียว -->
        <guide-body v-else-if="guide" :guide="guide" @navigate="go" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ACTORS, GROUPS, TASK_GUIDES, STATUS_META } from "./collegeTaskCatalog";
import GuideBody from "./CollegeTaskGuideBody.vue";

export default {
  name: "CollegeTaskGuide",

  components: { GuideBody },

  props: {
    value: { type: Boolean, default: false },
    taskKey: { type: String, default: null },
    groupKey: { type: String, default: null },
    // tasks จากศูนย์แจ้งเตือน (ถ้ามี) ใช้แสดงสถานะปัจจุบันของแต่ละภารกิจในโหมดกลุ่มงาน
    tasks: { type: Array, default: () => [] }
  },

  data() {
    return { actors: ACTORS, guides: TASK_GUIDES, openPanel: undefined };
  },

  computed: {
    group() {
      return this.groupKey ? GROUPS[this.groupKey] || null : null;
    },
    guide() {
      return this.taskKey ? TASK_GUIDES[this.taskKey] || null : null;
    },
    heading() {
      if (this.group) return "ขั้นตอนการทำงาน: " + this.group.title;
      return this.guide ? this.guide.title : "";
    }
  },

  watch: {
    value(open) {
      if (!open || !this.group) return;
      // เปิดภารกิจแรกที่ยังค้างอยู่ให้อัตโนมัติ
      const idx = this.group.flow.findIndex(k => {
        const t = this.tasks.find(x => x.key === k);
        return t && (t.status === "todo" || t.status === "partial");
      });
      this.openPanel = idx >= 0 ? idx : undefined;
    }
  },

  methods: {
    statusOf(key) {
      const t = this.tasks.find(x => x.key === key);
      if (!t) return null;
      return t.period_state === "upcoming" ? STATUS_META.upcoming : STATUS_META[t.status];
    },
    go(to) {
      this.$emit("input", false);
      if (this.$route.path !== to) this.$router.push(to);
    }
  }
};
</script>

<style scoped>
.ctg-card {
  border-radius: 14px !important;
  overflow: hidden;
}
.ctg-head {
  background: #263238;
  color: #fff;
  padding: 14px 18px !important;
}
.ctg-head-text {
  line-height: 1.3;
}
.ctg-head-title {
  font-size: 1.05rem;
  font-weight: 700;
  word-break: break-word;
}
.ctg-head-sub {
  font-size: 0.78rem;
  opacity: 0.8;
}
</style>
